import type { TypedSelectOption } from "./selectOptions";

declare module "./selectOptions" {
  interface SelectOptionRegistry {
    primary_order_status: TypedSelectOption<
      "order_status",
      {},
      PrimaryOrderStatusType
    >;
    approval_status: TypedSelectOption<
      "approval_status",
      {},
      ApprovalStatusType
    >;
    fulfillment_status: TypedSelectOption<
      "fulfillment_status",
      {},
      SalesOrderFulfillmentStatusType
    >;
  }
}

export const PRIMARY_ORDER_STATUSES = [
  "DRAFT",
  "REJECTED",
  "PROCESSING",
  "COMPLETE",
  "VOID",
] as const;
export type PrimaryOrderStatusType = (typeof PRIMARY_ORDER_STATUSES)[number];

export const APPROVAL_STATUSES = [
  "APPROVED",
  "PENDING",
  "REJECTED",
  "VOID",
] as const;
export type ApprovalStatusType = (typeof APPROVAL_STATUSES)[number];

export const SALES_ORD_FILL_STATUSES = [
  "APPROVAL",
  "REJECTED",
  "FULFILL",
  "PARTIAL",
  "FULL",
  "COMPLETE",
  "VOID",
] as const;
export type SalesOrderFulfillmentStatusType =
  (typeof SALES_ORD_FILL_STATUSES)[number];
